// src/components/auth/AuthModal.js
import React, { useState, useEffect } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';

function AuthModal({ isOpen, onClose, mode = 'login', showBenefits = true }) {
  const [currentMode, setCurrentMode] = useState(mode);
  
  // Update currentMode when the mode prop changes
  useEffect(() => {
    if (mode) {
      setCurrentMode(mode);
    }
  }, [mode]);

  // If modal is not open, don't render anything
  if (!isOpen) return null;

  const handleSuccess = () => {
    if (onClose) onClose();
  };

  const switchToLogin = () => {
    setCurrentMode('login');
  };

  const switchToSignup = () => {
    setCurrentMode('signup');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-800">
              {currentMode === 'login' ? 'Welcome Back' : 'Join PilatesPlanner'}
            </h2>
            <button 
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 focus:outline-none"
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {showBenefits && (
            <div className="bg-blue-50 rounded-lg p-4 mb-6">
              <h3 className="font-medium text-blue-800 mb-2">
                {currentMode === 'login' ? 'Welcome back!' : 'Create an account to:'}
              </h3>
              <ul className="text-blue-700 text-sm space-y-1">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-blue-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Save up to 5 custom workouts <span className="text-xs">(Basic tier)</span></span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-blue-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Track your workout history</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-blue-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Save your favorite exercises</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-blue-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Create user profiles for different needs</span>
                </li>
              </ul>
              <div className="mt-2 text-xs text-blue-700">
                <span className="font-medium">Premium tier</span> unlocks unlimited workouts, detailed analytics, and more!
              </div>
            </div>
          )}
          
          {currentMode === 'login' ? (
            <LoginForm 
              onSuccess={handleSuccess}
              onSwitchToSignup={switchToSignup}
              onCancel={onClose}
            />
          ) : (
            <SignupForm
              onSuccess={handleSuccess}
              onSwitchToLogin={switchToLogin}
              onCancel={onClose}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthModal;